export function isOneOf<T, U extends T>(v: T, ...values: U[]): v is U;
export function isOneOf<U>(v: unknown, values: Iterable<U>): v is U;
export function isOneOf(v: unknown, ...values: unknown[]) {
  const set = new Set<unknown>(values);
  return set.has(v);
}

export const createArrayTypeGuard =
  <T, U extends T>(typeGuard: (value: T) => value is U) =>
  (values: T[]): values is U[] =>
    values.every(typeGuard);

export const isNonNullish = <T>(value: T): value is NonNullable<T> =>
  value !== null && value !== undefined;

export const allAreNonNullish = createArrayTypeGuard(isNonNullish);

export const propsAreNonNullish = <T extends object, K extends keyof T>(
  obj: T,
  ...keys: K[]
): obj is T & { [P in K]-?: NonNullable<T[P]> } =>
  keys.every((key) => isNonNullish(obj[key]));

export const propsAreNotUndefined = <T extends object, K extends keyof T>(
  obj: T,
  ...keys: K[]
): obj is T & { [P in K]-?: Exclude<T[P], undefined> } =>
  keys.every((key) => obj[key] !== undefined);
